import React from "react";
import styled from "styled-components";
import classNames from 'classnames';

export default function FullButton({ title, action, border, className, disabled }) {
  return (
    <Wrapper
      className={classNames("animate pointr radius8", className)}
      onClick={action ? (e) => action(e) : null}
      border={border}
      disabled={disabled}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 2px solid ${(props) => (props.border ? "var(--wc-main-secondary)" : "var(--wc-main-secondary)")};
  background-color: ${(props) => (props.border ? "transparent" : "var(--wc-main-secondary)")};
  width: 100%;
  padding: 15px 30px;
  outline: none;
  color: ${(props) => (props.border ? "var(--wc-main-secondary)" : "#fff")};
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none;
  
  &:hover {
    background-color: ${(props) => (props.border ? "var(--wc-main-secondary)" : "var(--wc-main-primary)")};
    border-color: var(--wc-main-primary);
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    transform: none;
    box-shadow: none;
  }
  
  @media (max-width: 480px) {
    padding: 12px 20px;
    font-size: 14px;
  }
`;

